module.exports = __webpack_public_path__ + "img/twint.2344aa52.svg";